<template>
	<div class = "keyword_nav_container pt-2" style="height:50px;">
		<ul class="nav nav-tabs">
			<li>
				<a class="nav-link" @click="setTab('detail')" :class = "currentPage == 'detail' ? 'active' : ''">Details</a>
			</li>
			<li>
				<a class="nav-link" @click="setTab('tables')" :class = "currentPage == 'tables' ? 'active' : ''">Table</a>
			</li>
		</ul>
	</div>
</template>

<script>
export default {
    name: 'DetailTabs',
    data() {
        return {

        }
    },
	mounted(){
		console.log('rendered');
	},
	computed:{
		currentPage:{
			set(val) {
				this.$store.state.accounts.accountTab =  val;
			},
			get() {
				return this.$store.state.accounts.accountTab;
			}
		}
	},
	methods:{
		setTab(val){
			
			 this.$store.state.accounts.accountTab = val
		}
	}
}
</script>
